import axios from "axios";
import { loginModel } from "../../../modules/login/models/loginModel";
import { NewUserModel } from "../../../modules/userManagement/models/newUserModel";
import { UserDataModel } from "../../models/userDataModel";

export const UserApi = () => {
  const userData: UserDataModel = JSON.parse(
    localStorage.getItem("techsauce-campaign-user-data") ?? "{}"
  );

  const realApi = axios.create({
    baseURL: "https://campaign.techsauce.co/api",
    timeout: 15000,
    headers: {
      Authorization: userData.token ?? "",
    },
  });

  return {
    login: async (loginData: loginModel) => {
      const result = await realApi.post("/login", loginData);
      return result.data;
    },

    users: async () => {
      const result = await realApi.get("/users");
      return result.data;
    },

    addNewUser: async (user: NewUserModel) => {
      const result = await realApi.post("/users/newUser", user);
      return result.data;
    },

    editUser: async (user: NewUserModel, id?: string) => {
      const result = await realApi.patch(`/users/${id}/edit`, user);
      return result.data;
    },

    toggleCampaignActive: async (id?: string) => {
      const result = await realApi.post(`/users/${id}/toggleUserActive`);
      return result.data;
    },

    deleteCampaign: async (id?: string) => {
      const result = await realApi.delete(`/users/${id}`);
      return result.data;
    },

    userData: async (id?: string) => {
      const result = await realApi.get(`/users/${id}`);
      return result.data;
    },
  };
};
